<template>
    <div>
        <li
            v-for="(report, index) in session.available_report_templates"
            :key="report.id"
            :id="'report-' + report.id"
            :class="[
                'list-unstyled p-b-10 p-t-10',
                index !== session.available_report_templates.length -1 ? 'border-bottom' : '',
            ]"
        >
            <p>
                {{ report.report_name }}
                <i
                    v-if="report.vv_user_signature_required"
                    class="fa fa-exclamation-circle text-warning m-r-5"
                    v-tooltip="$t('general:required')"
                ></i>
                <i
                    v-if="getDocumentsForTemplate(report.id).length > 0"
                    class="fa fa-check text-success"
                    v-tooltip="$t('virtual_visit:signed')"
                ></i>
            </p>
            <a
                v-if="!session.is_completed"
                :class="[
                    'btn',
                    OTsubscribers.length > 0
                        ? 'btn-info'
                        : 'btn-default disabled',
                ]"
                type="button"
                @click="sendReportToClient(report.id)"
            >
                <i :class="getReportButtonIconClass(report.id)"></i>
                {{ $t("general:send_form") }}
            </a>

            <a
                :class="[
                    'open-modal m-l-5 btn',
                    getDocumentsForTemplate(report.id).length > 0
                        ? 'btn-success'
                        : 'btn-default disabled',
                ]"
                :href="generateGetDocumentUrl(report.id)"
                id="show-report"
            >
                {{ $t("general:show") }}
            </a>
        </li>
    </div>
</template>

<script>
import ApiService from "@/components/utils/api.service.js";

export default {
    props: {
        session: {
            type: Object,
            required: true,
        },
    },
    data: function () {
        return {
            step_no: 1,
        };
    },
    methods: {
        getDocumentsForTemplate: function (template_id) {
            return this.session.documents.filter(function (document) {
                return document.report_template === template_id && document.result;
            });
        },
        generateGetTemplateUrl: function (template_id) {
            return ApiService.constructUrl(`/virtual-visit/get_template/${this.session.session_id}/${template_id}`);
        },
        generateGetDocumentUrl: function (template_id) {
            let documents = this.getDocumentsForTemplate(template_id);
            if (documents.length === 0) { return ""; }
            let document_id = documents[0].id;
            return ApiService.constructUrl(`/virtual-visit/get_session_document/${document_id}`);
        },
        getReportButtonIconClass: function (template_id) {
            let cls = "report-spinner";
            if (this.reports_in_progress.includes(template_id)) {
                cls += " fa fa-spin fa-spinner";
            }
            return cls;
        },
        sendReportToClient: function (template_id) {
            this.$store.commit("addReportInProgress", template_id);
            this.$store.state.OTsession.signal({
                type: "send-report",
                data: this.generateGetTemplateUrl(template_id),
            });
        },
    },
    computed: {
        OTsession() {
            return this.$store.state.OTsession;
        },
        OTsubscribers() {
            return this.$store.state.OTsubscribers;
        },
        reports_in_progress() {
            return this.$store.state.reports_in_progress;
        },
        unsignedReports() {
            return this.session.available_report_templates.filter((report) => {
                return this.getDocumentsForTemplate(report.id).length == 0;
            });
        },
        unsignedRequiredReports() {
            return this.unsignedReports.filter((report) => {
                return report.vv_user_signature_required;
            });
        },
        signedReports() {
            return this.session.available_report_templates.filter((report) => {
                return this.getDocumentsForTemplate(report.id).length > 0;
            });
        },
        signedRequiredReports() {
            return this.signedReports.filter((report) => {
                return report.vv_user_signature_required;
            });
        },
    },
    watch: {
        // NOTE: This was moved to 'VirtualVisitCall.vue'
        // OTsession: {
        //     immediate: true,
        //     handler: function (newVal, oldVal) {
        //         if (newVal && !oldVal) {
        //             this.setupOTSessionListeners();
        //         }
        //     },
        // },
        // When a new session is loaded, check if all required reports are signed
        session: {
            immediate: true,
            handler: function (newVal, oldVal) {
                if (this.unsignedRequiredReports && this.unsignedRequiredReports.length == 0) {
                    this.$emit("finished", this.step_no);
                }
            },
        },
    },
};
</script>

<style scoped>
.border-bottom {
    border-bottom: 1px solid whitesmoke;
}
</style>